import { deepCopy } from "../../utils";
import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { showDangerToast } from "../../validation/ToastContainer";
import { securedFetch } from "../../auth/authService";
import { DOMAIN_MANAGEMENT_API } from "../../vars";
import { ACTION_DOMAINS_LOADED } from "./AddDeviceModalReducer";

export function list() {
    return securedFetch(DOMAIN_MANAGEMENT_API)
        .then(response => response.json())
        .then(data => {
            data = deepCopy(data);
            store.dispatch(createAction(ACTION_DOMAINS_LOADED)({ domains: data }));
            return data;
        }).catch(err => {
            showDangerToast(err.message, "Error");
        })
}
